<template>
  <el-container class="companies">
    <el-header class="header-style">
      <el-divider content-position="left">线索反馈内容分析</el-divider>
      <el-row>
        <el-col :span="6">
          <el-input
            v-model="searchArr.keyword"
            size="mini"
            clearable
            placeholder="关键词:反馈内容"
            @blur="getThreadFeedbackList"
            @clear="getThreadFeedbackList"
          >
          </el-input>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 276px)" :data="threadFeedback" size="medium" border style="width: 100%" v-cloak>
        <el-table-column label="关键词" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.communication_note">
              <p
                v-html="highlightText(scope.row.communication_note, searchArr.keyword)"
              ></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="线索编码" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.thread_code">
              <el-tooltip :content="scope.row.thread_code.tag_code" placement="top">
                <span class="count-style">{{ scope.row.thread_code.tag_code }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="沟通人员" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.uname">
              <el-tooltip :content="scope.row.uname" placement="top">
                <span class="count-style">{{ scope.row.uname }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="沟通时间" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.created_time">
              <el-tooltip :content="scope.row.created_time" placement="top">
                <span class="count-style">{{ scope.row.created_time }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="tr mt-10"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "ThreadFeedback",
  data() {
    return {
      searchArr: {
        keyword: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      threadFeedback: [],
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getThreadFeedbackList() {
      this.$axios
        .get(
          "/api/admin/thread/thread_feedback/index?page=" +
            this.pageOption.currentPage +
            "&page_size=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.threadFeedback = data.data.list.data;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getThreadFeedbackList();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getThreadFeedbackList();
    },
    highlightText(text, search) {
      const regex = new RegExp(search, "gi");
      return text.replace(regex, `<span style="color: red;">${search}</span>`);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.highlight {
  color: red !important;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.companies >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.companies {
  marginLeft();
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 100px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    // overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 15px;
    }
  }
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/clues_manage/ThreadFeedback.vue